import React from 'react';
import { Theme } from '../../types';

export const ThemeContext = React.createContext<{ theme?: Theme } | null>(null);

export const ThemeProvider = ThemeContext.Provider;
